import styled from "styled-components";
import { Grid, TextField } from "@material-ui/core";
import { STFormTitleTypography } from "../Components/STFormTitleTypohraphy";

export const STModalWrapper = styled(Grid)`
&&&& {
  width: 620px;
}
`;

export const SSTFormTitleTypography = styled(STFormTitleTypography)`
  &&& {
    margin-bottom: 25px;
    font-size: 18px;
  }
`;

export const ButtonsGrid = styled(Grid)`
  &&& {
    margin-top: 15px;
  }
`;

export const STNote = styled.div`
  white-space: pre-line;
  padding: 7px 
  border: 1px solid #ddd;
`;

export const STTextField = styled(TextField)`
  &&& {
    margin-top: 10px;
  }
`;